import { Message, MessageGroup, MessageThread } from '@mangovoice/types'

export type MessageGroupCreatedPayload = MessageGroup
export type MessageGroupsMarkedReadPayload = {
  messageGroupIds: number[]
}
export type MessageThreadMarkedReadPayload = {
  threadId: number
}
export type ThreadMessageSentPayload = {
  threadId: number
}
export type ThreadCreatedPayload = {
  thread: MessageThread
  message?: Message
}
export type MessageThreadUpdatedPayload = {
  thread: MessageThread
}

export enum MessagingEmitterEventType {
  MESSAGE_GROUP_CREATED = 'MESSAGE_GROUP_CREATED',
  MESSAGE_GROUPS_MARKED_READ = 'MESSAGE_GROUPS_MARKED_READ',
  MESSAGE_THREAD_MARKED_READ = 'MESSAGE_THREAD_MARKED_READ',
  MESSAGE_THREAD_CREATED = 'THREAD_CREATED',
  MESSAGE_THREAD_UPDATED = 'THREAD_UPDATED',
  THREAD_MESSAGE_SENT = 'THREAD_MESSAGE_SENT',
}

export type MessagingEmitterPayloadMap = {
  [MessagingEmitterEventType.MESSAGE_GROUP_CREATED]: MessageGroupCreatedPayload
  [MessagingEmitterEventType.MESSAGE_GROUPS_MARKED_READ]: MessageGroupsMarkedReadPayload
  [MessagingEmitterEventType.MESSAGE_THREAD_MARKED_READ]: MessageThreadMarkedReadPayload
  [MessagingEmitterEventType.THREAD_MESSAGE_SENT]: ThreadMessageSentPayload
  [MessagingEmitterEventType.MESSAGE_THREAD_CREATED]: ThreadCreatedPayload
  [MessagingEmitterEventType.MESSAGE_THREAD_UPDATED]: MessageThreadUpdatedPayload
}
